'use client';

import { c as _c } from "react/compiler-runtime";
import { ReactNode, useRef, useState } from 'react';
import { SideDrawer } from '@libs/shared-ui';
import { AccountButton } from '../../../shared';
import { useAccountAuthenticated } from '../../use-account-authenticated';
import './drawer.scss';
type DrawerProps = {
  children: (helper: {
    close: () => void;
  }) => ReactNode;
};
export function Drawer(t0) {
  const $ = _c(13);
  const {
    children
  } = t0;
  const triggerRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const {
    firstName
  } = useAccountAuthenticated();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => requestAnimationFrame(() => triggerRef.current?.focus());
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const focusTrigger = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsOpen(false);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const close = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <AccountButton ref={triggerRef} onClick={() => setIsOpen(true)} />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== firstName) {
    t4 = <SideDrawer.Header><SideDrawer.Title className="account-authenticated-drawer__title">Hi, <span className="account-authenticated-drawer__capitalize">{firstName}</span>!</SideDrawer.Title></SideDrawer.Header>;
    $[3] = firstName;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== children) {
    t5 = children({
      close
    });
    $[5] = children;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <SideDrawer.Body>{t5}</SideDrawer.Body>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== isOpen || $[10] !== t4 || $[11] !== t6) {
    t7 = <>{t3}<SideDrawer isOpen={isOpen} onOpenChange={setIsOpen} onClose={focusTrigger}>{t4}{t6}</SideDrawer></>;
    $[9] = isOpen;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}